import React from 'react';
import { Box, SimpleGrid, Skeleton, VStack } from '@chakra-ui/react';

interface LoadingSkeletonProps {
    sectionsCount?: number;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ 
    sectionsCount = 4 
}) => {
    return (
        <VStack spacing={6} align="stretch">
            {Array.from({ length: sectionsCount }, (_, index) => (
                <Box key={index} px={4}>
                    {/* Section Title Skeleton */}
                    <Skeleton height="24px" width="200px" mb={4} borderRadius="md" />
                    
                    {/* Chart Skeletons with 1:2 ratio */}
                    <SimpleGrid
                        templateColumns={{ base: "1fr", md: "1fr 2fr" }}
                        spacing={4}
                    >
                        <Skeleton height="300px" borderRadius="lg" />
                        <Skeleton height="300px" borderRadius="lg" />
                    </SimpleGrid>
                </Box>
            ))}
        </VStack>
    );
};

export default LoadingSkeleton;
